import { useEffect, useState } from "react"
import { Link } from 'react-router-dom'
import { Input, Button, Table, Space, Select, DatePicker } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable } from "../../tool/axios"
import BreadCrumb from '../../component/BreadCrumb'
import 'moment/locale/zh-cn'
import _ from 'lodash'

const { Column } = Table
const { Option } = Select
const { RangePicker } = DatePicker

type fetchParams = {
    user_name: string | undefined,
    phone: string | undefined,
    register_type: string | undefined,
    date: any
}

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: false
}

export default function () {

    let fetchOtherParamsTmpl: fetchParams = {
        user_name: undefined,
        phone: undefined,
        register_type: undefined,
        date: null
    }

    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)
    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })

    // 列表数据
    const [data, setData] = useState<any>([])
    // 列表Loading
    const [loading, setLoading] = useState<boolean>(false)

    useEffect(() => {
        fetch({ pagination, fetchOtherParams })
    }, [pagination.current])

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const handleSearch = () => {
        const p = { ...pagination }
        p.current = 1

        fetch({ pagination: p, fetchOtherParams })
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current

        setPagination(p)
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        setLoading(true)

        let iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        let params: any = { ...fetchOtherParams }

        if (params.date) {
            params.register_start_date = params.date[0].format('YYYY-MM-DD')
            params.register_end_date = params.date[1].format('YYYY-MM-DD')
            delete params.date
        }

        axiosTable.get('/member_center/member/page_list', {
            params: {
                ...iPagination,
                ...params
            }

        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total

                setPagination(p)
                setData(response.records)
            }

            setLoading(false)
        })
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)

        let p: any = { ...pagination }
        p.current = 1

        setPagination(p)
        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    return (<div className="common-page">
        {/* 会员中心 -> 会员管理 -> 会员列表 */}
        <BreadCrumb position={['会员中心', '会员列表']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <Input style={{ width: '120px', marginRight: 5, marginBottom: 12 }} placeholder="会员昵称" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'user_name') }} value={fetchOtherParams.user_name} />
                <Input style={{ width: '120px', marginRight: 5, marginBottom: 12 }} placeholder="会员手机号" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'phone') }} value={fetchOtherParams.phone} />
                <Select allowClear style={{ width: 120, marginRight: 5, marginBottom: 12 }} placeholder="注册渠道" value={fetchOtherParams.register_type} onChange={(v: string) => { handleChange(v, 'register_type') }}>
                    <Option value={1} key={1}>会员小程序</Option>
                    <Option value={2} key={2}>后台录入</Option>
                    <Option value={3} key={3}>商城小程序</Option>
                </Select>

                <RangePicker style={{ marginRight: 5, marginBottom: 12 }} placeholder={["注册开始日期", "注册结束日期"]} value={fetchOtherParams.date} onChange={(v: any) => { handleChange(v, 'date') }} />
            </Space>

            <div style={{ marginTop: 10 }}>
                <Button className="search-btn" style={{ marginRight: 12, marginBottom: 12 }} icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>
                <Button style={{ marginRight: 12, marginBottom: 12 }} icon={<RedoOutlined />} onClick={resetForm} >重置</Button>
            </div>
        </div>

        <div className="common-main">
            <Table loading={loading} dataSource={data} scroll={{ x: 'max-content' }} bordered={true} rowKey="member_id" pagination={pagination} onChange={handleTableChange}>
                <Column title="会员昵称" dataIndex="user_name" key="user_name" />
                <Column title="会员手机号" dataIndex="phone" key="phone" />
                <Column title="会员生日" dataIndex="birthday" key="birthday" />
                <Column title="会员积分" dataIndex="points" key="points" />
                <Column title="商城消费金额" dataIndex="mall_consume_amount" key="mall_consume_amount" />
                <Column title="注册渠道" dataIndex="register_type" key="register_type" render={(v: number) => {
                    switch (v) {
                        case 1:
                            return '会员小程序'
                        case 2:
                            return '后台录入'
                        default:
                            return '商城小程序'
                    }
                }} />
                <Column title="注册时间" dataIndex="create_date" key="create_date" />

                <Column
                    title="操作"
                    key="action"
                    render={(text, record: any) => {
                        return (<Space size="middle">
                            <Link to={"/member_detail/" + record.member_id}>查看</Link>
                        </Space>)
                    }}
                />
            </Table>
        </div>
    </div>)
}